import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import {
  CheckCircle,
  XCircle,
  Loader2,
  ArrowRight,
} from "lucide-react";

import api from "../api";

export default function VerifyEmail() {
  const { key } = useParams();
  const navigate = useNavigate();

  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState(
    "Verifying your email..."
  );

  useEffect(() => {
    const verifyEmail = async () => {
      if (!key) {
        setStatus("error");
        setMessage("Invalid verification link.");
        return;
      }

      try {
        await api.post(
          "/api/auth/register/verify-email/",
          {
            key,
          }
        );

        setStatus("success");
        setMessage(
          "Your email has been verified successfully."
        );

        setTimeout(() => {
          navigate("/");
        }, 3000);
      } catch (err) {
        console.error(
          "Email verification error:",
          err.response?.data || err.message
        );

        setStatus("error");

        setMessage(
          err.response?.data?.detail ||
            err.response?.data?.message ||
            "This verification link is invalid or has expired."
        );
      }
    };

    verifyEmail();
  }, [key, navigate]);

  return (
    <div className="min-h-screen bg-[#F7F1E3] flex items-center justify-center p-6">

      <div className="relative w-full max-w-md rounded-3xl bg-[#FFFDF8] shadow-xl border border-[#E5DDCC] p-10 text-center overflow-hidden">

        {/* Decorative teal circle */}
        <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full bg-[#0F766E]/10" />

        <div className="absolute -bottom-24 -left-24 w-48 h-48 rounded-full bg-[#0F766E]/5" />

        <div className="relative z-10">

          {/* =========================
              LOADING
          ========================= */}
          {status === "loading" && (
            <>
              <div className="w-20 h-20 mx-auto rounded-full bg-[#E6F3F1] flex items-center justify-center">
                <Loader2
                  className="animate-spin text-[#0F766E]"
                  size={42}
                />
              </div>

              <h1 className="mt-6 text-3xl font-bold text-[#1F2937]">
                Verifying...
              </h1>

              <p className="mt-3 text-[#8A8172]">
                Please wait while we verify your email address.
              </p>
            </>
          )}

          {/* =========================
              SUCCESS
          ========================= */}
          {status === "success" && (
            <>
              <div className="w-20 h-20 mx-auto rounded-full bg-[#E6F3F1] flex items-center justify-center">
                <CheckCircle
                  className="text-[#0F766E]"
                  size={56}
                />
              </div>

              <h1 className="mt-6 text-3xl font-bold text-[#1F2937]">
                Email Verified!
              </h1>

              <p className="mt-3 text-[#5F665F]">
                {message}
              </p>

              <p className="mt-2 text-sm text-[#9A9285]">
                Redirecting you to the homepage...
              </p>

              <button
                onClick={() => navigate("/login")}
                className="
                  mt-8
                  w-full
                  bg-[#0F766E]
                  hover:bg-[#0B5F59]
                  text-white
                  py-3
                  rounded-xl
                  font-semibold
                  transition
                  duration-300
                  flex
                  justify-center
                  items-center
                  gap-2
                  shadow-sm
                  hover:shadow-md
                "
              >
                Go to Login

                <ArrowRight size={18} />
              </button>
            </>
          )}

          {/* =========================
              ERROR
          ========================= */}
          {status === "error" && (
            <>
              <div className="w-20 h-20 mx-auto rounded-full bg-[#FCE8E6] flex items-center justify-center">
                <XCircle
                  className="text-red-500"
                  size={56}
                />
              </div>

              <h1 className="mt-6 text-3xl font-bold text-[#1F2937]">
                Verification Failed
              </h1>

              <p className="mt-3 text-[#5F665F]">
                {message}
              </p>

              <button
                onClick={() => navigate("/login")}
                className="
                  mt-8
                  w-full
                  bg-[#0F766E]
                  hover:bg-[#0B5F59]
                  text-white
                  py-3
                  rounded-xl
                  font-semibold
                  transition
                  duration-300
                  flex
                  justify-center
                  items-center
                  gap-2
                  shadow-sm
                  hover:shadow-md
                "
              >
                Return to Login

                <ArrowRight size={18} />
              </button>
            </>
          )}

        </div>
      </div>
    </div>
  );
}